<template>
    <b-row v-bind:class="{'run-loading':Loadings.list}">
        <b-col md="12">
            <div class="boxShadow clear-border setBorderRadius pl-20 pr-20 heig-frame-child-tab">
                <b-row class="content mt-10">
                    <b-col md="3">
                        <div class="control pull-left pl-16">
                            <div class="list innerControl">
                                <div class="custom-control custom-control-inline">
                                    <b-form-checkbox type="checkbox" class="uniform" id="checkAll" v-model="allSelected" @input="toggleSelected">
                                    </b-form-checkbox>
                                </div>
                                <span class="search" @click="reloadAllUser(0)" v-b-tooltip.hover title="Refresh">
                                    <img src="img/reLoad.png" alt="reload">
                                </span>
                                <span class="search" v-if="$checkRole($accessModule.users, 'create')" @click="openModalAdd" v-b-tooltip.hover title="Create">
                                    <img src="img/blankIcon.png" alt="blank">
                                </span>
                                <span class="search" v-if="selected.length > 0 && $checkRole($accessModule.users, 'delete')" @click="openModalRemoveUser" v-b-tooltip.hover title="Delete">
                                    <img src="img/deleteIcon.png" alt="delete">
                                </span>
                            </div>
                        </div>
                        <b-modal :no-close-on-backdrop="true" id="modal-RemoveAlert" title="remove to user" hide-footer hide-header :centered="true" ref="modal-RemoveAlert">
                            <div class="center">Please select at least 1 line to delete!!!</div>
                            <b-button-group class="btn-group">
                                <b-button class="custom-btn" @click="closeModalRemoveAlert">OK</b-button>
                            </b-button-group>
                        </b-modal>
                        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" ref="modal-Remove">
                            <div class="center">Are you sure you want to<br />delete <strong>This Item</strong>?</div>
                            <b-button-group class="btn-group">
                                <b-button class="custom-btn" @click="closeModalRemoveUser">No</b-button>
                                <b-button class="custom-btn" @click="removeUser" :disabled="isAction">Yes</b-button>
                            </b-button-group>
                        </b-modal>
                        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Employee" hide-footer :centered="true" ref="modal-Create">
                            <b-form>
                                <b-row>
                                    <b-col md="12">
                                        <gofix-form-input label="Employee Name" v-model="$v.User.name.$model" required></gofix-form-input>
                                        <gofix-form-dropdown label="Role" vLabel="name" :multiple="true" v-model="User.roles" :options="RoleItems.data">
                                        </gofix-form-dropdown>
                                        <gofix-form-input-number label="Phone Number" v-model="User.primary_phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false"></gofix-form-input-number>
                                        <gofix-form-input label="Email" v-model="$v.User.email.$model" required></gofix-form-input>
                                        <gofix-form-input label="Password" v-model="User.password" type="password" autocomplete="new-password"></gofix-form-input>
                                        <b-form-checkbox v-model="User.active" class="ml-16 mt-20"><span class="ml-2">Active</span></b-form-checkbox>
                                    </b-col>
                                    <b-col md="12">
                                        <b-button-group class="d-block text-right">
                                            <gofix-button label="SUBMIT" @click="save" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.User, $accessModule.users)" noBorder></gofix-button>
                                        </b-button-group>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-modal>
                    </b-col>
                    <b-col md="9">
                        <div class="control">
                            <Pagination :Items="this.Items" v-model="pages"></Pagination>
                            <div class="list innerControl  ml-2">
                                <span class="filter" v-on:click="filterActive" v-bind:class="[filterActive, activeClass ? 'active' : '']">
                                    <div class="tooltip">Filter</div>
                                    <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.30512 13H12.7496V10.8333H8.30512V13ZM0.527344 0V2.16667H20.5273V0H0.527344ZM3.86068 7.58333H17.194V5.41667H3.86068V7.58333Z" fill="#999999" />
                                    </svg>
                                </span>
                                <span class="search">
                                    <div class="tooltip">Setting</div>
                                    <b-dropdown :disabled="!$checkRole($accessModule.users, 'create')" class="btn btnConfig">
                                        <b-dropdown-item href="#">Import</b-dropdown-item>
                                        <b-dropdown-item href="#">Export</b-dropdown-item>
                                        <ColumnSetting v-model="columnActive" :nameTable="this.nameTable"></ColumnSetting>
                                    </b-dropdown>
                                </span>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="12" class="mt-20 filterOrg" v-bind:class="[filterActive, activeClass ? 'open' : '']">
                        <b-row>
                            <b-col md="1">
                                <gofix-form-input label="ID" v-model="pages.filter.id.value" @change="searchUser"></gofix-form-input>
                            </b-col>
                            <b-col md="2">
                                <gofix-form-input label="Name" v-model="pages.filter.name.value" @change="searchUser"></gofix-form-input>
                            </b-col>
                            <b-col md="2">
                                <gofix-form-input label="Email" v-model="pages.filter.email.value" @change="searchUser"></gofix-form-input>
                            </b-col>
                            <b-col md="2">
                                <gofix-form-input label="Mobile" v-model="pages.filter.address_primary_phone.value" @change="searchUser"></gofix-form-input>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="12" class="mt-20">
                        <b-row class="rowOrg">
                            <template v-for="(item, index) in Items.data">
                                <b-col md="3" :key="index">
                                    <div class="boxOrg min-height-150">
                                        <div class="title">
                                            <div class="custom-control custom-checkbox custom-control-inline">
                                                <input type="checkbox" :value="item.id" v-model="selected" class="custom-control-input" :id="'customInChk'+item.id">
                                                <label class="custom-control-label" :for="'customInChk'+item.id"></label>
                                            </div>
                                            <strong class="mr-3">{{item.id}}</strong>
                                            <div class="custom-name">
                                                <strong>{{item.name}}</strong>
                                            </div>
                                            <ul class="actions">
                                                <li>
                                                    <button v-if="$checkRole($accessModule.users, 'update')" @click.stop="editUser(item)">
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2582 4.69276C17.5832 5.01776 17.5832 5.54276 17.2582 5.86776L15.7332 7.39276L12.6082 4.26776L14.1332 2.74276C14.2889 2.58672 14.5003 2.49902 14.7207 2.49902C14.9411 2.49902 15.1525 2.58672 15.3082 2.74276L17.2582 4.69276ZM2.5 17.0844V14.5511C2.5 14.4344 2.54167 14.3344 2.625 14.2511L11.7167 5.15943L14.8417 8.28442L5.74167 17.3761C5.66667 17.4594 5.55833 17.5011 5.45 17.5011H2.91667C2.68333 17.5011 2.5 17.3178 2.5 17.0844Z" fill="#999999" />
                                                        </svg>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button v-if="$checkRole($accessModule.users, 'delete')" @click.stop="openModalRemoveUser(item)">
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M2.5 5H17.5" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M6.66602 5.00033V3.33366C6.66602 2.89163 6.84161 2.46771 7.15417 2.15515C7.46673 1.84259 7.89066 1.66699 8.33268 1.66699H11.666C12.108 1.66699 12.532 1.84259 12.8445 2.15515C13.1571 2.46771 13.3327 2.89163 13.3327 3.33366V5.00033M15.8327 5.00033V16.667C15.8327 17.109 15.6571 17.5329 15.3445 17.8455C15.032 18.1581 14.608 18.3337 14.166 18.3337H5.83268C5.39065 18.3337 4.96673 18.1581 4.65417 17.8455C4.34161 17.5329 4.16602 17.109 4.16602 16.667V5.00033H15.8327Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M8.33398 9.16699V14.167" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M11.666 9.16699V14.167" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="content" @click.stop="editUser(item)">
                                            <b-row>
                                                <b-col md="12">
                                                    <label>Role</label>
                                                    <template v-for="(roles, index) in item.roles">{{roles.name}}<span v-if="index != Object.keys(item.roles).length - 1">, </span> </template>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col md="12">
                                                    <label>Email</label> {{ (item.email.length > 0) ? item.email : '--' }}
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col md="12">
                                                    <label>Mobile</label> {{ primary_phone(item) }}
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                </b-col>
                            </template>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import { mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import { filters } from '@/_filterVar.js'
export default {
    name: 'employees',
    props: {
        company: {
            type: Object,
            required: false,
            default: () => null
        },
    },
    components: {},
    data() {
        return {
            titleModal: 'Create User',
            activeClass: false,
            activeFilter: false,
            allSelected: false,
            selected: [],
            pages: {
                isCMS: '1',
                page: 1,
                totalPage: 1,
                limit: 100,
                useDatabaseView: true,
                filter: JSON.parse(JSON.stringify(filters['user']))
            },
            columnActive: {
                fields: [{
                        key: 'actions',
                        label: '',
                        thClass: 'checkbox-column text-center',
                        tdClass: 'checkbox-column text-center',
                        thStyle: "width:50px",
                        isActive: 1
                    },
                    {
                        key: 'id',
                        label: 'ID',
                        thStyle: "width:50px",
                        isActive: 1
                    },
                    {
                        key: 'organization',
                        label: 'Company',
                        isActive: 1
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        isActive: 1
                    },
                    {
                        key: 'mobile',
                        label: 'Mobile',
                        isActive: 1
                    },
                    {
                        key: 'email',
                        label: 'Email',
                        isActive: 1
                    },
                    {
                        key: 'role',
                        label: 'Role',
                        isActive: 1
                    },
                    {
                        key: 'active',
                        label: 'Status',
                        isActive: 1
                    }
                ],
                show: [],
                hide: []
            },
            User: {
                id: '',
                name: '',
                organisation_id: 0,
                email: '',
                password: '',
                repassword: '',
                address: [],
                role: [],
                primary_phone: '',
                active: true,
                address_id: 0,
                mailing_address_id_tmp: 0
            },
            isAction: false,
            organizations: [],
            nameTable: 'tableEmployeesCompany',
            ids: [],
            group_tags: "Client",
            Items: {
                data: [],
                total: 0,
            }
        }
    },
    mixins: [validationMixin],
    validations: {
        User: {
            name: {
                required,
            },
            email: {
                required,
                email,
            }
        }
    },
    async created() {
        this.pages.filter.type_user = 'all';
        this.getUser();
        this.getRole();
    },
    computed: {
        ...mapGetters({
            // Items: 'v2UserController/ListingUser',
            Loadings: 'v2UserController/Loadings',
            RoleItems: 'RoleController/RoleItems',
        })
    },
    watch: {
        selected: function(val) {
            if (this.Items.data.length > val.length) {
                this.allSelected = false
                return
            }
            if (val.length > 0 && this.Items.data.length == val.length) {
                this.allSelected = true
            }
        },
        "pages.limit": function(val) {
            if (this.pages.page === 1) {
                this.movePage();
            } else {
                this.pages.page = 1;
            }
        },
        "pages.page": function(val) {
            this.movePage();
        },
        ClientContractID: function(val) {
            this.getUser();
        }
    },
    methods: {
        getUser() {
            this.pages.filter.client_contract_id.value = null
            if(this.ClientContractID && this.ClientContractID.id) {
                this.pages.filter.client_contract_id.value = this.ClientContractID.id
            }
            this.pages.filter.organisation_id.value = this.$route.params.company_id
            this.$store.dispatch(`v2UserController/getListUser2`, this.pages)
            .then(result => {
                this.Items.data  = result.items
                this.Items.total = result.total
            }).catch(err => {
                console.log(err)
                this.$alertNotification("Can not load employees list", "danger");
            })
        },
        primary_phone: function(item) {
            if (!item.address || !item.address.length) return '--';
            if (!item.mailing_address_id) {
                return item.address[0].primary_phone ? item.address[0].primary_phone : '--';
            }

            let itemAdrress = item.address.filter(address => address.id == item.mailing_address_id);
            if (itemAdrress.length) {
                return itemAdrress[0].primary_phone ? itemAdrress[0].primary_phone : '--';
            }
            return '--';
        },
        async editUser(item) {
            if(!this.$checkRole(this.$accessModule.users, 'update')) return;
            this.User = Object.assign({}, item);
            let itemAdrress = item.address.filter((address, index) => {
                if (address.id == item.mailing_address_id) {
                    this.User.mailing_address_id_tmp = index;
                    return address;
                }
            });
            if (itemAdrress.length) {
                this.User.address_id = itemAdrress[0].id
                this.User.primary_phone = itemAdrress[0].primary_phone
            } else {
                this.User.address_id = item.address && item.address[0] ? item.address[0].id : 0
                this.User.primary_phone = item.address && item.address[0] ? item.address[0].primary_phone : ''
            }
            this.User.password = ''
            await this.$refs['modal-Create'].show();
        },
        async reloadAllUser(keepFilter = 0) {
            this.selected = []
            if (!keepFilter) {
                this.pages.filter.id.value = '';
                this.pages.filter.name.value = '';
                this.pages.filter.email.value = '';
                this.pages.filter.address_primary_phone.value = '';
            }

            this.getUser();
        },
        async save() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.$v.User.$touch()
                if (this.$v.User.$error) {
                    this.isAction = false;
                } else {
                    let user = Object.assign({}, this.User);
                    this.isAction = true;

                    let api = 'SaveUser';
                    let keyMessage = 'adding'
                    user.role = user.roles || []
                    if (user.id) {
                        api = 'updateUser'
                        keyMessage = 'editing'
                        if (user.address)
                            if (user.address.length) {
                                user.address = user.address.map(address => {
                                    if (address.id == this.User.address_id) {
                                        address.primary_phone = this.User.primary_phone;
                                        return address;
                                    }
                                    return address;
                                });
                            } else {
                                user.mailing_address_id_tmp = 0
                                user.address = [{
                                    primary_phone: this.User.primary_phone,
                                    building_name: "",
                                    city: null,
                                    contact_name: null,
                                    country: "Singapore",
                                    display_address: "",
                                    display_name: "",
                                    email: null,
                                    email_verified: false,
                                    first_name: null,
                                    full_address: "",
                                    geo_location: null,
                                    id: null,
                                    last_name: null,
                                    phone_verified: false,
                                    postal_code: "",
                                    salutation: null,
                                    secondary_phone: null,
                                    street_name: "",
                                    street_no: "",
                                    unit_no: ""
                                }];
                            }

                    } else {
                        user.organisation_id = this.$route.params.company_id
                        user.address = [{
                            primary_phone: this.User.primary_phone,
                            building_name: "",
                            city: null,
                            contact_name: null,
                            country: "Singapore",
                            display_address: "",
                            display_name: "",
                            email: null,
                            email_verified: false,
                            first_name: null,
                            full_address: "",
                            geo_location: null,
                            id: null,
                            last_name: null,
                            phone_verified: false,
                            postal_code: "",
                            salutation: null,
                            secondary_phone: null,
                            street_name: "",
                            street_no: "",
                            unit_no: ""
                        }];
                        user.mailing_address_id_tmp = 0
                    }
                    this.$store.dispatch(`v2UserController/${api}`, user)
                        .then(result => {
                            this.isAction = false;
                            if (result.code && result.code == 400) {
                                return this.$alertNotification(result.message, "danger");
                            }

                            this.reloadAllUser();
                            this.$refs['modal-Create'].hide()
                            this.$alertNotification(this.$notificationV2(keyMessage, 'user'));
                        })
                        .catch(error => {
                            this.isAction = false;
                            this.$store.commit("v2UserController/setLoadings", { key: "list", val: false });
                            if (error.error.message.password) {
                                this.$alertNotification(error.error.message.password[0], "danger");
                            }
                            if (error.error.message.email) {
                                this.$alertNotification(error.error.message.email[0], "danger");
                            }
                        })
                }
            }, 500)
        },
        toggleSelected() {
            if (this.allSelected) {
                this.selected = [];
                for (let i in this.Items.data) {
                    this.selected.push(this.Items.data[i].id)
                }
                return
            }
            if (!this.allSelected && this.Items.data.length == this.selected.length) {
                this.selected = []
            }
        },
        removeUser() {
            if (this.ids.length) {
                this.$store.dispatch('v2UserController/deleteUser', {
                    ids: this.ids
                }).then(response => {
                    this.selected = []
                    this.reloadAllUser(1)
                    this.$alertNotification(this.$notificationV2('deleting', 'user'));
                }, error => {
                    console.error("Got nothing from server. Prompt user to check internet connection and try again!!")
                });
                this.$refs['modal-Remove'].hide()
            }
        },
        openModalAdd() {
            this.$v.$reset();
            this.User = {
                id: '',
                name: '',
                organisation_id: 0,
                email: '',
                password: '',
                repassword: '',
                address: [],
                primary_phone: ''
            }
            if (this.$route.path.includes('supplier')) {
                this.User.organisation_id = this.$route.params.account_suplier_id
            }

            if (this.$route.path.includes('all-company')) {
                this.User.organisation_id = this.$route.params.company_id
            }

            this.$refs['modal-Create'].show()
        },
        openModalRemoveUser(data) {
            this.ids = []
            this.ids = this.ids.concat(this.selected)
            if (data) this.ids.push(data.id)
            if (this.ids.length > 0) {
                this.$refs['modal-Remove'].show()
                return
            }
            this.$refs['modal-RemoveAlert'].show()
        },
        closeModalRemoveUser() {
            this.$refs['modal-Remove'].hide()
        },
        closeModalRemoveAlert() {
            this.$refs['modal-RemoveAlert'].hide()
        },
        filterActive() {
            this.activeClass = !this.activeClass
        },
        async movePage() {
            this.selected = []
            this.getUser();
        },
        async searchUser() {
            this.pages.page = 1;
            this.selected = [];
            this.getUser();
        },
        getRole() {
            if (this.company.hasOwnProperty("is_fm_company") && this.company.hasOwnProperty("is_supplier")) {
                if (this.company.is_fm_company) this.group_tags = "FM";
                if (this.company.is_supplier) this.group_tags = "Supplier";
            } else {
                this.group_tags = "Tenant";
            }
            this.$store.dispatch("RoleController/getRoleItems", {
                filter: {
                    group_tags: this.group_tags
                }
            });
        }
    }
}
</script>